/* @flow */

import type { ManageCanvas, DrawFunc } from './Common';
import { GridWidth, GridHeight } from './Common';
import ZoomContext from './ZoomContext';

export default class CanvasManager implements ManageCanvas {
  zoomContext: ZoomContext;

  // level subs
  toDrawPlatform = [];
  toDrawRamp = [];
  toDrawUmbrella = [];
  toDrawHero = [];
  toDrawParticle = [];
  toDrawGoal = [];
  toDrawFloor = [];

  constructor(canvasElm: HTMLCanvasElement) {
    this.zoomContext = new ZoomContext(canvasElm);
    this.draw();
  }
  cleanup() {
    this.toDrawPlatform = [];
    this.toDrawRamp = [];
    this.toDrawUmbrella = [];
    this.toDrawHero = [];
    this.toDrawParticle = [];
    this.toDrawGoal = [];
    this.toDrawFloor = [];
  }
  subscribePlatform(drawFunc: DrawFunc) {
    this.toDrawPlatform.push(drawFunc);
  }
  subscribeParticle(drawFunc: DrawFunc) {
    this.toDrawParticle.push(drawFunc);
  }
  subscribeHero(drawFunc: DrawFunc) {
    this.toDrawHero.push(drawFunc);
  }
  subscribeRamp(drawFunc: DrawFunc) {
    this.toDrawRamp.push(drawFunc);
  }
  subscribeUmbrella(drawFunc: DrawFunc) {
    this.toDrawUmbrella.push(drawFunc);
  }
  subscribeGoal(drawFunc: DrawFunc) {
    this.toDrawGoal.push(drawFunc);
  }
  subscribeFloor(drawFunc: DrawFunc) {
    this.toDrawFloor.push(drawFunc);
  }
  getCanvasTools() {
    return {
      ctx: this.zoomContext,
    };
  }
  drawStats(stats: *) {
    const tools = this.getCanvasTools();
    tools.ctx.fillStyle = 'black';
    tools.ctx.fillRect(0, 0, 160, 16 + 10 * stats.length);
    tools.ctx.fillStyle = 'white';
    for (var i = 0; i < stats.length; i++) {
      tools.ctx.fillText(stats[i][1], 10, 16 + 10 * i);
      tools.ctx.fillText(stats[i][0], 60, 16 + 10 * i);
    }
  }
  draw() {
    const tools = this.getCanvasTools();

    // wipe screen
    tools.ctx.fillStyle = 'black';
    tools.ctx.fillRect(0, 0, GridWidth, GridHeight);

    this.toDrawPlatform.forEach(drawFunc => drawFunc(tools));
    this.toDrawGoal.forEach(drawFunc => drawFunc(tools));
    this.toDrawRamp.forEach(drawFunc => drawFunc(tools));
    this.toDrawUmbrella.forEach(drawFunc => drawFunc(tools));
    this.toDrawHero.forEach(drawFunc => drawFunc(tools));
    this.toDrawParticle.forEach(drawFunc => drawFunc(tools));
    this.toDrawFloor.forEach(drawFunc => drawFunc(tools));

    this.zoomContext.drawFrame();
    window.requestAnimationFrame(() => this.draw());
  }
}



// WEBPACK FOOTER //
// ./src/CanvasManager.js